export interface Queue {
  id: number;
  name: string;
  users: QueueUser[];
  agent_ring_timeout: number;
  connection_timeout: number;
  extension_number: number;
  group_type: string;
  is_recreatable: boolean;
  module: string;
  moh: {
    file_url: string;
    id: number;
    name: string;
    source: string;
    type: string;
  }
  _resolveConflicts?: boolean;
  _recreating?: boolean;
  _automaticRecreating?: boolean;
  _selected?: boolean;
  user_strategy: RING_STRATEGY;
}

export interface QueueUpdateRequest {
  id: number;
  name: string;
  extension_number: number;
  user_ids: number[];
  media_id: number;
  connection_timeout: number;
  agent_ring_timeout: number;
  is_recreatable: boolean;
  user_strategy: RING_STRATEGY;
}

export interface QueueUser {
  id: number;
  first_name: string;
  last_name: string;
  extension_number: number;
  email: string;
  _login?: boolean;
  _logout?: boolean;
}

export enum RING_STRATEGY {
  LINEAR = 'LINEAR',
  RANDOM = 'RANDOM'
}

export enum QUEUE_MIGRATION_STAGE {
  RESOURCE_CREATION = 'RESOURCE_CREATION',
  RESOURCE_INITIALIZATION = 'RESOURCE_INITIALIZATION',
  OLD_RESOURCE_DELETION = 'OLD_RESOURCE_DELETION',
  RESOURCE_CREATION_ROLLBACK = 'RESOURCE_CREATION_ROLLBACK'
}

export interface MigrationFailedStage {
  stage: QUEUE_MIGRATION_STAGE,
  error_message: string
}

export interface QueueMigrateResult {
  resource: Queue,
  failed_stages: MigrationFailedStage[]
  success: boolean
}

export interface QueueMigrateResponse extends Array<QueueMigrateResult> {}
